export default "<p>\r\n  Home works!\r\n</p>\r\n"